/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_GatesInputs */

const en_nav_gates = /** @type {(inputs: Nav_GatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval gates`)
};

/**
* | output |
* | --- |
* | "Approval gates" |
*
* @param {Nav_GatesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_gates = /** @type {((inputs?: Nav_GatesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_GatesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_gates(inputs)
});